export function stripBadPatternIds(object) {
  Object
    .entries(object)
    .forEach(([key, value]) => {
      return Object.entries(value['attack-patterns']).forEach(([tactic, array]) => {
        array.forEach((val, i) => {
          if (typeof val.id === 'object') {
            array.splice(i, 1)
          }
        })
      })
    })
  return object
}
